import angular from 'angular';
import resource from 'angular-resource'
import appConfig from '../ConfigModule/ConfigModule';

let pageResource = angular.module('cms.page.resource', [resource, appConfig])
    .factory('PageResource', function ($resource, CONFIG) {
        /** @ngInclude */

        return $resource(CONFIG.API_URL + '/pages/:id', {id: '@id'}, {
            'findAll': {method: 'GET'},
            'find': {method: 'GET'},
            'save': {method: 'POST'},
            'update': {method: 'PUT', params: {id: '@id'}},
            'delete': {method: 'DELETE', params: {id: '@id'}},
            'findFormData': {method: 'GET', url: CONFIG.API_URL + '/pages/form/:pageId' , params: {pageId: '@pageId'}},
            'findFormDataDetails': {method: 'GET', url: CONFIG.API_URL + '/pages/form/data/:id', params: {id: '@id'}},
            'deleteFormData': {method: 'DELETE', url: CONFIG.API_URL + '/pages/form/:id', params: {id: '@id'}}
        }, {
            stripTrailingSlashes: true
        });
    });

export default pageResource.name;


// WEBPACK FOOTER //
// ./src/cmsCore/PagesModules/PageResource.js